module.exports = __webpack_public_path__ + "static/media/password.d0ff39c0.svg";